import { render, staticRenderFns } from "./design.vue?vue&type=template&id=79cad8da"
import script from "./design.vue?vue&type=script&lang=js"
export * from "./design.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79cad8da')) {
      api.createRecord('79cad8da', component.options)
    } else {
      api.reload('79cad8da', component.options)
    }
    module.hot.accept("./design.vue?vue&type=template&id=79cad8da", function () {
      api.rerender('79cad8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/design.vue"
export default component.exports